import React from 'react';
import $  from 'jquery';
import { OverlayTrigger } from 'react-bootstrap';
import ToolTips from './Tooltips';

class MyOverlayTrigger extends React.Component{

    constructor(props){
        super(props);
        this.toolTipId = '';
        this.hoverToolstip = this.hoverToolstip.bind(this);
    }

    hoverToolstip(){
        var tooltipEle = document.getElementById(this.toolTipId);
        $(tooltipEle).css({'z-index':99999});
    }

    render(){
        const { 
          contentText, 
          toolTipId, 
          overrideClazz, 
          placement, 
          arrowOffsetTop 
        } = this.props;
       
        this.toolTipId = toolTipId;      
        const tooltip = (
            <ToolTips 
              className={overrideClazz ? overrideClazz : "s-tooltip"} 
              id={this.toolTipId}
              arrowOffsetTop={arrowOffsetTop ? arrowOffsetTop : ''}
            >
              <span dangerouslySetInnerHTML={{__html: contentText}}></span>
            </ToolTips>
        );
        return(
            <OverlayTrigger placement={placement} id={`overlay-${this.toolTipId}`} defaultOverlayShown={false}  overlay={tooltip} onEntered={this.hoverToolstip}> 
                  {this.props.children}
            </OverlayTrigger>
        )
    }
}
export default MyOverlayTrigger


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/OverlayTrigger.js